'use client';

import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';
import { List, ListItem, ListItemButton, ListItemIcon } from '@mui/material';
import { DownloadPdfUserButton } from '@prismo-io/feature-pdf';
import { type ToolsOrganizationsT, UserAccessType, type UserAccessTypeT, type UsersT } from '@prismo-io/schemas';
import type { FC } from 'react';
type Props = {
  user: Pick<UsersT, 'id' | 'full_name' | 'has_aura' | 'has_helio'>;
  anchorOrigin?: {
    horizontal: number | 'center' | 'left' | 'right';
    vertical: number | 'center' | 'bottom' | 'top';
  };
  transformOrigin?: {
    horizontal: number | 'center' | 'left' | 'right';
    vertical: number | 'center' | 'bottom' | 'top';
  };
  access: UserAccessTypeT;
  organization?: Pick<ToolsOrganizationsT, 'id' | 'email'>;
  cvIsEnable?: boolean;
};
const withTalentPdf: UserAccessTypeT[] = [UserAccessType.enum.TALENT, UserAccessType.enum.EXPERT_FREE, UserAccessType.enum.STARTER, UserAccessType.enum.LEAD, UserAccessType.enum.EXPERT];
const talentPdfIsEnable: UserAccessTypeT[] = [UserAccessType.enum.TALENT, UserAccessType.enum.EXPERT];
const withExpertPdf: UserAccessTypeT[] = [UserAccessType.enum.EXPERT_FREE, UserAccessType.enum.STARTER, UserAccessType.enum.LEAD, UserAccessType.enum.EXPERT];
export const PdfDownloadsMobileBtn: FC<Props> = (props: Props) => {
  const {
    user,
    access,
    anchorOrigin = {
      horizontal: 'right',
      vertical: 'top'
    },
    transformOrigin = {
      horizontal: 'left',
      vertical: 'top'
    },
    organization = undefined,
    cvIsEnable = false
  } = props;
  if (access === UserAccessType.enum.VISITOR) {
    return null;
  }
  if (!cvIsEnable && !withTalentPdf.includes(access) && !withExpertPdf.includes(access)) {
    return null;
  }
  return <List data-sentry-element="List" data-sentry-component="PdfDownloadsMobileBtn" data-sentry-source-file="index.tsx">
      <ListItem disablePadding data-sentry-element="ListItem" data-sentry-source-file="index.tsx">
        <DownloadPdfUserButton organization={organization} users={[user]} anchorOrigin={anchorOrigin} transformOrigin={transformOrigin} config={{
        cv: {
          visible: cvIsEnable
        },
        talent: {
          visible: withTalentPdf.includes(access),
          disabled: !talentPdfIsEnable.includes(access)
        },
        expert: {
          visible: withExpertPdf.includes(access),
          disabled: access !== UserAccessType.enum.EXPERT
        }
      }} data-sentry-element="DownloadPdfUserButton" data-sentry-source-file="index.tsx">
          {(props: any) => <ListItemButton {...props}>
              <ListItemIcon sx={{
            minWidth: 'auto'
          }}>
                <DownloadForOfflineRoundedIcon fontSize="large" sx={{
              color: 'primary.main'
            }} />
              </ListItemIcon>
            </ListItemButton>}
        </DownloadPdfUserButton>
      </ListItem>
    </List>;
};